<template>
  <v-form>
    <v-container class="mb-4">
      <v-subheader>Informe ao menos uma referencia comercial. Isto permitirá ao
        comprador constatar a confiabilidade de sua empresa.
      </v-subheader>
      <v-card class="mb-4">
        <div class="px-4 pt-4">
          <v-row dense>
            <v-col cols="12" sm="7">
              <v-text-field
                outlined
                hide-details
                label="Empresa"
                class="required"
                maxlength="150"
                :error="$v.referencia.empresa.$error"
                @blur="$v.referencia.empresa.$touch()"
                v-model="referencia.empresa"
              />
            </v-col>
            <v-col cols="12" sm="5">
              <v-text-field
                outlined
                hide-details
                label="Contato"
                class="required"
                maxlength="150"
                :error="$v.referencia.contato.$error"
                @blur="$v.referencia.contato.$touch()"
                v-model="referencia.contato"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="7">
              <v-text-field
                outlined
                hide-details
                label="E-mail"
                maxlength="150"
                :error="$v.referencia.email.$error"
                @blur="$v.referencia.email.$touch()"
                v-model="referencia.email"
              />
            </v-col>
            <v-col cols="12" sm="5">
              <v-text-field
                outlined
                hide-details
                label="Telefone"
                class="required"
                maxlength="150"
                v-mask="['(##) ####-####', '(##) #####-####']"
                :error="$v.referencia.formattedTelefone.$error"
                @blur="$v.referencia.formattedTelefone.$touch()"
                v-model="referencia.formattedTelefone"
              />
            </v-col>
          </v-row>
        </div>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary"
                 @click="adicionar"
                 :disabled="$v.$invalid">
            <v-icon>mdi-plus</v-icon>
            Adicionar
          </v-btn>
        </v-card-actions>
      </v-card>
      <px-lista-referencias :referencias="empresa.referencias"
                            @remove="remove" />
    </v-container>
    <v-btn color="primary" class="mr-2"
           :disabled="!empresa.referencias.length"
           @click="emitReady">
      Próximo
    </v-btn>
    <v-btn @click="emitBack">
      Voltar
    </v-btn>
  </v-form>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import ListaReferencias from './ListaReferencias.vue';

export default {
  props: {
    empresa: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      referencia: {
        empresa: null,
        contato: null,
        email: null,
        telefone: null,
        formattedTelefone: null,
      },
    };
  },
  methods: {
    emitReady() {
      this.$emit('ready');
    },
    emitBack() {
      this.$emit('back');
    },
    adicionar() {
      this.referencia.telefone = this.referencia.formattedTelefone.match(/\d+/g).join('');
      this.empresa.referencias.push(this.referencia);
      this.referencia = {
        empresa: null,
        contato: null,
        email: null,
        telefone: null,
        formattedTelefone: null,
      };
      this.$v.$reset();
    },
    remove(index) {
      this.empresa.referencias.splice(index, 1);
    },
  },
  components: {
    pxListaReferencias: ListaReferencias,
  },
  validations: {
    referencia: {
      empresa: {
        required,
      },
      contato: {
        required,
      },
      email: {
        email,
      },
      formattedTelefone: {
        required,
      },
    },
  },
};
</script>
